import React from 'react';
import alertic from 'src/assets/images/yellow-alert.png';

function ProPositionWarning() {
  return (
    <div className=' steps-inner my-3 active '>
    <div className="checkout-titles d-flex justify-content-center gap-2">
            <img
                className=""
                src={alertic} />
                <h2>WARNING: PROPOSITION 65</h2>
    </div>
    <div className='checkbox-steps-content text-center justify-content-center py-2'>
    Cancer and Reproductive Harm -
    <a href='https://www.p65warnings.ca.gov/' target='_blank' className='text-underline'> www.P65Warnings.ca.gov</a>
    </div>
</div>
  )
}

export default ProPositionWarning